import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import { ConstructionPhasesAction } from "../../../actions";
import ToolsDescription from "../components/description";
import ToolsSearch from "../components/search";
import Table from "../../../components/table";
import Button from "../../../components/button";
import { Sortable } from "../../../components/sort";
import { Confirm } from "../../../components/confirm";
import { EmptyState } from "../../../components/emptyState";
import { BoxLoading } from "../../../components/loading";
import DefaultPhasesModal from "../../../lib/components/defaultConstruction/phases";
import { FilterComponent } from "./components/filters";
import { ToolsTop, ToolsBody, TruncateText } from "../style";
import { ToPersian } from "../../../lib/changeNumber";
import ToEnglish from "../../../lib/persianNumberToEnglish";
import { isEqual } from "lodash";

class ConstructionPhase extends Component {
  constructor(props) {
    super(props);
    this.LEVEL1 = 1;
    this.LEVEL2 = 2;
    this.state = {
      favorite: false,
      query: null,
      sortField: "name",
      sortType: "asc",
      level:
        parseInt(queryString.parse(props.history.location.search).level) || 1,
      defaultModal: false,
      list: this.normalizeDataForLevels(true)
    };
    this.sortHandleClick = this.sortHandleClick.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.toggleFavorite = this.toggleFavorite.bind(this);
    this.deleteHandleClick = this.deleteHandleClick.bind(this);
    this.rowRender = this.rowRender.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.openDefault = this.openDefault.bind(this);
  }

  static getDerivedStateFromProps(props, state) {
    let result = { ...state };
    const level = queryString.parse(props.history.location.search).level;
    result.favorite = queryString.parse(
      props.history.location.search
    ).favtories;
    if (level && level !== state.level) {
      result.level = parseInt(level);
    }
    if (props.list.length > 0 && state.defaultModal) {
      result.defaultModal = false;
    }

    return result;
  }

  componentDidMount() {
    if (!this.props.list.length) {
      this.props.getAll(this.LEVEL1);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      !isEqual(prevProps.list, this.props.list) ||
      prevState.level !== this.state.level
    ) {
      this.normalizeDataForLevels();
    }
  }

  normalizeDataForLevels(returnOutput) {
    const { list, history } = this.props;
    let level2List = [];
    for (let i = 0; i < list.length; i++) {
      if (Array.isArray(list[i].children))
        level2List.push(...list[i].children);
    }
    let output = [];
    let levelTemp =
      parseInt(queryString.parse(history.location.search).level) || this.LEVEL1;
    if (levelTemp === this.LEVEL1) {
      output = list;
    } else if (levelTemp === this.LEVEL2) {
      output = level2List;
    }
    if (returnOutput) {
      return output;
    }
    this.setState({ list: output });
  }

  sortHandleClick() {
    const { sortType } = this.state;

    this.setState({
      sortType: sortType === "desc" ? "asc" : "desc"
    });
  }

  onEdit(id) {
    this.props.history.push(`/construction-phase/${id}/edit`);
  }

  onSearch(query) {
    this.setState({
      query: query
    });
  }

  toggleFavorite(id, status) {
    this.props.addFavorite(id, status);
  }

  deleteHandleClick(item) {
    this.setState({ showConfirm: true, deleteItemId: item.id });
  }

  openDefault() {
    this.setState({ defaultModal: true });
  }

  rowRender(item) {
    const { accounting } = this.props;
    const { level } = this.state;

    return (
      <Table.Row key={item.id}>
        <Table.Cell onClick={() => this.onEdit(item.id)} className="name">
          {item.name}
        </Table.Cell>
        {accounting && (
          <Table.Cell
            onClick={() => this.onEdit(item.id)}
            className="accounting"
          >
            {item.accounting_code}
          </Table.Cell>
        )}
        {parseInt(localStorage.getItem("construction_phase_level")) == 2 &&
          (level === 1 ? (
            <Table.Cell onClick={() => this.onEdit(item.id)} className="childs">
              <TruncateText width="25vw">
                {item.children &&
                  item.children.map(child => child.name).join(",")}
              </TruncateText>
            </Table.Cell>
          ) : (
            <Table.Cell onClick={() => this.onEdit(item.id)} className="parent">
              {item.parent && item.parent.name}
            </Table.Cell>
          ))}
        <Table.Cell
          onClick={() => this.onEdit(item.id)}
          className="description"
        >
          <TruncateText width="25vw">{item.description}</TruncateText>
        </Table.Cell>
        <Table.Cell className="row-controls-button">
          <div className="hidden-td">
            <i
              onClick={() => this.toggleFavorite(item.id, !item.is_favorite)}
              className={
                "no-select icon mapsa-filled-favourites-star yellow" +
                (item.is_favorite ? " active" : "")
              }
              title="منتخب"
            />
            <i
              onClick={() => this.deleteHandleClick(item)}
              className="no-select icon mapsa-trash red"
              title="حذف"
            />
          </div>
        </Table.Cell>
      </Table.Row>
    );
  }

  render() {
    const description =
      "منظور از فعالیت‌های پروژه، سرفصل های هزینه‌ای می‌باشد. مثلا در پروژه‌های ساختمانی مانند گچکاری، تیغه چینی، نقاشی و یا هزینه‌های عمومی، مجوزهای قانونی و...";
    const { loading, accounting } = this.props;
    const {
      showConfirm,
      deleteItemId,
      query,
      favorite,
      sortField,
      sortType,
      level,
      defaultModal,
      list
    } = this.state;

    const filteredList = list
      .filter(
        item =>
          !query ||
          item.name.indexOf(ToEnglish(query)) !== -1 ||
          item.name.indexOf(ToPersian(query)) !== -1
      )
      .filter(item => (favorite ? item.is_favorite : true))
      .sort((prev, next) =>
        sortType === "asc"
          ? prev[sortField] < next[sortField]
            ? -1
            : 1
          : prev[sortField] > next[sortField]
          ? -1
          : 1
      );

    return (
      <React.Fragment>
        {!loading ? (
          list.length !== 0 ? (
            <React.Fragment>
              <ToolsTop>
                <ToolsDescription
                  icon="icon mapsa-steps"
                  color="#0b9b7a"
                  title="فعالیت‌ها"
                  description={description}
                />
                <ToolsSearch onSearch={this.onSearch} query={query} />
              </ToolsTop>
              <ToolsBody>
                {filteredList.length > 0 ? (
                  <Table>
                    <Table.Header>
                      <Table.Row>
                        <Table.HeaderCell className="name">
                          <Sortable
                            sort={{
                              sort_field: sortField,
                              sort_type: sortType,
                              value: "name"
                            }}
                            currency={false}
                            label={"نام فعالیت"}
                            sortHandleClick={this.sortHandleClick}
                          />
                        </Table.HeaderCell>
                        {accounting && (
                          <Table.HeaderCell className="accounting">
                            کد حسابداری
                          </Table.HeaderCell>
                        )}
                        {parseInt(
                          localStorage.getItem("construction_phase_level")
                        ) === 2 &&
                          (level === 1 ? (
                            <Table.HeaderCell
                              className="childs"
                              style={{ maxWidth: "30%" }}
                            >
                              فعالیت‌های مرتبط
                            </Table.HeaderCell>
                          ) : (
                            <Table.HeaderCell
                              className="parent"
                              style={{ maxWidth: "30%" }}
                            >
                              سرگروه
                            </Table.HeaderCell>
                          ))}
                        <Table.HeaderCell
                          className="description"
                          style={{ maxWidth: "30%" }}
                        >
                          توضیحات
                        </Table.HeaderCell>
                        <Table.HeaderCell className="row-controls-button"></Table.HeaderCell>
                      </Table.Row>
                    </Table.Header>
                    <Table.Body>{filteredList.map(this.rowRender)}</Table.Body>
                  </Table>
                ) : (
                  <EmptyState tabIcon={"icon mapsa-search"}>
                    متاسفانه موردی یافت نشد.
                  </EmptyState>
                )}
              </ToolsBody>
              <Confirm
                show={showConfirm}
                content={{
                  type: "danger",
                  icon: "icon mapsa-notification",
                  message: "آیا از پاک کردن این فعالیت اطمینان دارید؟",
                  acceptButtonText: "حذف",
                  rejectButtonText: "انصراف"
                }}
                acceptHandler={() => {
                  this.props.remove(deleteItemId);
                  this.setState({ showConfirm: false });
                }}
                rejectHandler={() => this.setState({ showConfirm: false })}
                close={() => this.setState({ showConfirm: false })}
              />
            </React.Fragment>
          ) : (
            <EmptyState tabIcon={"icon mapsa-outline-layers"}>
              {description}
              {level === 1 && (
                <React.Fragment>
                  <Button
                    style={{ marginTop: "10px" }}
                    onClick={this.openDefault}
                    btn="outline"
                    borderless
                  >
                    افزودن فعالیت‌های پیش‌فرش
                  </Button>
                  <DefaultPhasesModal
                    show={defaultModal}
                    onClose={() => this.setState({ defaultModal: false })}
                  />
                </React.Fragment>
              )}
            </EmptyState>
          )
        ) : (
          <BoxLoading />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = store => {
  return {
    list: store.ConstructionPhase.data,
    loading: store.ConstructionPhase.loading,
    accounting:
      store.Init.data &&
      store.Init.data.project_setting.accounting_software !== null &&
      !!store.Init.data.project_setting.accounting_software.id
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAll: (level = 1) => {
      dispatch(ConstructionPhasesAction.getAllRequest(level));
    },
    addFavorite: (id, status) => {
      dispatch(ConstructionPhasesAction.addFavoriteRequest(id, status));
    },
    remove: id => {
      dispatch(ConstructionPhasesAction.removeRequest(id));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConstructionPhase)
);

const disableAdd = history => {
  return parseInt(queryString.parse(history.location.search).level) === 2;
};

const onIndexClick = (history, params = {}) => {
  const level = queryString.parse(history.location.search).level;

  return "/construction-phase?" + queryString.stringify({ ...params, level });
};

const onFavoriteClick = history => {
  return onIndexClick(history, { favtories: true });
};

export const Sidebar = {
  addButton: { title: "ایجاد فعالیت", disable: disableAdd },
  menu: [
    { title: "فعالیت‌ها", icon: "mapsa-steps", link: onIndexClick },
    {
      title: "فعالیت‌های منتخب",
      icon: "mapsa-favourites-star",
      link: onFavoriteClick
    }
  ],
  subComponent: <FilterComponent />
};
